<template>
  <el-switch
      v-model="selected"
      active-color="#a9c83f"
      inactive-color="#03bcff"
      :active-text="stores[1].label"
      :inactive-text="stores[0].label"
      :active-value="stores[1].value"
      :inactive-value="stores[0].value"
  ></el-switch>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'StoreComponent',
  data() {
    return {
      stores: [
        {
          label: 'Itunes',
          value: 'itunes',
        },
        {
          label: 'Play',
          value: 'google_play',
        },
      ],
      // todo: use the value in store instead?
      selected: this.$route.params.storeName,
    };
  },
  methods: {
    ...mapActions({
      setFilterStore: 'game/setFilterStore',
    }),
  },
  watch: {
    selected(newVal) {
      this.$router.push({
        name: 'home',
        params: {
          ...this.$route.params,
          storeName: newVal,
        },
      }).catch(() => {});
      this.setFilterStore(newVal);
    },
    $route(to, from) {
      if (to.params.storeName !== from.params.storeName) {
        this.selected = to.params.storeName;
      }
    },
  },
};
</script>

<style scoped>
.select {
  width: 130px;
}

.option {
  float: left;
}
</style>
